import React from 'react';
import PropTypes from 'prop-types';
import classes from '../style.module.scss';
import Modal from '../Modal';
import Button from '../../Form/Buttons/Button';

const AttentionModal = ({
  isOpen, onClose, onSave, modalClassName, contentClassName, title, text, zIndex, loading,
}) => {
  const modalCls = [classes.attention_modal, modalClassName];

  const contentCls = [classes.attention_modal_content, contentClassName];

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      className={modalCls.join(' ')}
      zIndex={zIndex}
    >
      <div className={contentCls.join(' ')}>
        {title && <h2>{title}</h2>}

        <div className={classes.text}>{text}</div>

        <div className={classes.btns_wrapper}>
          <Button
            title="Cancel"
            type="button"
            onClick={onClose}
            clearButton
          />

          <Button
            title="Ok"
            type="button"
            onClick={onSave}
            loading={loading}
          />
        </div>
      </div>
    </Modal>
  );
};

AttentionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  title: PropTypes.string,
  text: PropTypes.any,
  modalClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  zIndex: PropTypes.number,
  loading: PropTypes.bool,
};

AttentionModal.defaultProps = {
  title: '',
  text: '',
  modalClassName: '',
  contentClassName: '',
  zIndex: 30,
  loading: false,
};

export default AttentionModal;
